<template>
    <div class="modal fade preview-modal-lg" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg fullscreen-modal" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Prévisualisation | {{ model.name }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row mb-2">
                        <div class="col-lg-12">
                            <div class="card animate animate-fadeIn">
                                <div class="card-body">
                                    <table class="patient-infos-table mb-2 w-100">
                                        <tbody>
                                            <tr>
                                                <td>Numéro</td>
                                                <td class="text-left">Nom & prénom(s)</td>
                                            </tr>
                                            <tr>
                                                <td>Sexe</td>
                                                <td class="text-left">Age</td>
                                            </tr>
                                            <tr>
                                                <td>Date de prélèvement</td>
                                                <td class="text-left">Médecin demandeur</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-2">
                        <div class="col-lg-12">
                            <div class="card animate animate-fadeIn">
                                <div class="card-body">
                                    <div id="result-preview-table">
                                        <table>
                                            <thead class="w-100" v-if="model.meta.table_header_name">
                                                <tr>
                                                    <th :colspan="headerRowLength" class="text-center">{{ model.meta.table_header_name }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(row, rowIndex) in model.meta.rows" :key="rowIndex" :class="{ 'bold-first-row': rowIndex === 0 }">
                                                    <td v-for="(cell, cellIndex) in row.cells" :key="cellIndex" :class="{ 'p-0': cell.subcells, 'px-2': cellIndex == 0 }">
                                                        <div v-if="!cell.subcells" style="min-height: 32px;">
                                                            {{ cell.value }}
                                                        </div>
                                                        <div v-else :class="cell.horizontal ? 'd-flex flex-row' : 'd-flex flex-column'">
                                                            <div v-for="(subcell, subcellIndex) in cell.subcells" :key="subcellIndex" class="w-100">
                                                                <div class="flex-grow-1 d-flex align-items-center justify-content-center"
                                                                    :style="{
                                                                        borderRight: cell.horizontal && subcellIndex < cell.subcells.length - 1 ? '1px solid #87A0C7' : '',
                                                                        borderBottom: !cell.horizontal && subcellIndex < cell.subcells.length - 1 ? '1px solid #87A0C7' : '',
                                                                        minHeight: '32px',
                                                                    }">
                                                                    {{ subcell.value !== '' ? subcell.value : '&nbsp;' }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="row mt-4">
                                        <label class="text-dark">Commentaire(s)/Interprétation(s)</label>
                                        <div class="comment-box w-100 p-2">
                                            <span class="text-muted">Zone réservée aux commentaires</span>
                                        </div>
                                    </div>

                                    <div class="row mt-4 justify-content-between">
                                        <div>Date _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _</div>
                                        <div>Le biologiste _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ </div>
                                    </div>

                                    <div class="row mt-4 justify-content-end">
                                        <div class="signature-box d-flex align-items-center justify-content-center">
                                            <span class="text-muted">Zone de signature et de cachet</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row justify-content-end">
                                        <div>
                                            <button type="button" class="btn btn-secondary-light-o btn-radius" data-dismiss="modal">
                                                Fermer la fenêtre
                                            </button>&nbsp;&nbsp;
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "preview-model-full-modal",
    props: [
        'model',
    ],
    data() {
        return {
            
        }
    },
    computed: {
        headerRowLength() {
            let maxLength = 0;
            if (this.model !== null) {
                for (const row of this.model.meta.rows) {
                    maxLength = Math.max(maxLength, row.cells.length);
                }
            }
            return maxLength;
        },
    },

    mounted() { },

}
</script>

<style src="../styles/preview-model.scss" lang="scss" scoped></style>